var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"modal__overlay",on:{"click":function($event){if($event.target !== $event.currentTarget){ return null; }_vm.$emit('click', $event)}}},[_c('div',{staticClass:"modal"},[_c('video',{attrs:{"controls":"","poster":_vm.poster,"autoplay":"true"}},[_c('source',{attrs:{"src":_vm.src,"type":"video/mp4"}}),_vm._v("\n            Your browser doesn't support HTML5 video tag.\n        ")])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-60b0c480","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ui/video-modal.vue
// module id = 295
// module chunks = 0